import { useTranslations } from 'next-intl';
import React from 'react';

import { TicketDto } from '@cineamo/api/models/ticket/TicketDto';

import Button from '@cineamo/ui/src/button/NewButton';
import { IconErrorSolid48 } from '@cineamo/ui/src/icons/ic-errorSolid';
import { IconReset16 } from '@cineamo/ui/src/icons/ic-reset';

import { useCartProvider } from '@cineamo/composables/src/providers/cartProvider';
export type TicketWithPass = {
    ticket: TicketDto;
    pkPass: File;
};

const PaymentFailedView = () => {
    const t = useTranslations('tickets');
    const { setCurrentStep: setStep } = useCartProvider();

    return (
        <div className="flex flex-col items-center space-y-16 container max-w-[600px] mx-auto pt-[48px]">
            <div className="w-48 h-48 flex items-center justify-center rounded-full bg-black">
                <IconErrorSolid48 className="text-red" />
            </div>
            <h1 className="text-headline-24 text-center">{t('payment-failed')}</h1>
            <p className="text-body-14 font-montserrat-medium whitespace-pre-wrap text-center">
                {t('payment-failed-message')}
            </p>
            <Button
                leadingIcon={<IconReset16 />}
                onClick={() => {
                    setStep('01_seat_picking');
                }}>
                {t('restart')}
            </Button>
        </div>
    );
};

export default PaymentFailedView;
